import { Component, EventEmitter, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SharedModule } from '../../../shared/shared.module';
import moment from 'moment';
import { SelectedLocation } from '../services/noon-reports.service';
import { MaterialDateRangeComponent, DateRange} from 'src/app/shared/components/material-date-picker/material-date-range.component';

@Component({
  selector: 'app-vessel-report-toolbar',
  templateUrl: './vessel-report-toolbar.component.html',
  imports: [SharedModule, MaterialDateRangeComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:true
})
export class VesselReportToolbarComponent implements OnInit {
  @Output()
    itemsSelected: EventEmitter<SelectedLocation[]> = new EventEmitter<SelectedLocation[]>();
  date: EventEmitter<DateRange> = new EventEmitter<DateRange>();
  locations: SelectedLocation[] = [];
  active!: boolean;
  visible!: boolean;
  dateRange!: DateRange;

  ngOnInit(): void {
    if(!this.dateRange) {
      this.dateRange = {
        startDate: moment(new Date()).subtract(100, 'days').toDate(),
        endDate: new Date()
      };
    }
  }

  selectDateRange(dateRange: DateRange) {
    if (dateRange) {
      this.date.emit(dateRange);
    }
  }

  onSelectAll() {
    this.active = !this.active;
    this.locations.forEach(i => {
      i.selected = this.active;
    });
    if (this.itemsSelected) {
      this.itemsSelected.emit(this.locations);
    }
  }

  onItemSelectedInternal(i: { selected: boolean; }) {
    i.selected = !i.selected;
    if (this.itemsSelected) {
      this.itemsSelected.emit(this.locations);
    }
  }

}
